var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 container is-centered has-text-centered"},[_c('a',{staticClass:"button is-size-3",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("Hier geht's zur Buchung!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }